/* src/app/views/product-create-search/new-product/new-product.component.scss */
.container {
  background: #ffffff;
  -webkit-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  -moz-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  box-shadow: 1.5px 3px 5px 1.5px rgb(184, 175, 184);
  width: 100%;
  max-width: none;
  margin: 0 0 24px;
  box-sizing: border-box;
  border-radius: 6px;
  overflow: visible;
}
.container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  float: left;
  margin-top: 20px;
}
.title {
  font-weight: normal;
  font-style: normal;
  font-size: 30pt;
  line-height: 50px;
  color: #333333;
  margin-left: 48px;
  margin-top: 10px;
}
form {
  border-radius: unset;
  padding: unset;
  box-shadow: unset;
}
.container-body {
  margin-top: 20px;
  margin-bottom: 20px;
  border: none;
}
.new-product-itens {
  padding: 8px 36px 0;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.new-product-itens-lines {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
  margin-bottom: 8px;
  margin-right: -12px;
  margin-left: -12px;
}
.new-product-itens-lines > [class*=col-] {
  padding: 0 12px 18px;
}
.new-product-itens-lines > .element-add-edit,
.new-product-itens-lines > .element-option-select {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
}
.new-product-itens-lines > .textarea-row {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.element-add-edit {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: initial;
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}
.element-add-edit-input {
  margin-top: 0;
  width: 100%;
  min-height: 40px;
}
.element-add-edit-label {
  margin-bottom: 8px;
}
.element-add-edit-filter {
  margin-bottom: 8px;
}
.element-add-edit .p-dropdown,
.element-add-edit .ui-dropdown,
.element-add-edit .p-inputtext,
.element-add-edit .ui-inputtext {
  width: 100% !important;
  min-height: 40px;
}
.space-first {
  margin-left: 0;
}
.space-second {
  margin-left: 0;
}
.space-third {
  margin-left: 0;
}
.large-text {
  height: 40px !important;
}
textarea.large-text {
  width: 100% !important;
  min-height: 96px !important;
  height: 96px !important;
}
.char-counter {
  font-size: 12px;
  color: #999999;
  margin-top: 6px;
}
.top-space {
  margin-top: 0;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 14px;
  margin-top: 20px;
  margin-left: 0;
  border-top: none !important;
  padding: 22px 36px 40px;
  max-width: 1240px;
  margin-right: auto;
  margin-left: auto;
}
.actions-section {
  width: 100%;
}
.btn-save {
  width: 137px;
  height: 48px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.btn-save-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.btn-save:hover {
  background: #044ea7;
}
.btn-return {
  width: 137px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.btn-return-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.btn-return:hover {
  background: #044ea7;
}
button.btn-return:hover .btn-return-label {
  color: #ffffff;
}
@media only screen and (max-width: 1024px) {
  .title {
    margin-left: 30px;
    font-size: 24pt;
    line-height: 36px;
  }
  .button-position {
    margin-left: 0;
    flex-wrap: nowrap;
    justify-content: flex-end;
    gap: 10px;
    padding: 20px 24px 28px;
  }
  .new-product-itens {
    padding: 8px 24px 0;
    max-width: 100%;
  }
  .space-first,
  .space-second,
  .space-third {
    margin-left: 0;
  }
  .top-space {
    margin-top: 0;
  }
}
@media only screen and (max-width: 768px) {
  .title {
    margin-left: 20px;
    font-size: 18pt;
    line-height: 28px;
  }
  .button-position {
    margin-left: 0;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    gap: 8px;
    padding: 18px 16px 20px;
  }
  .new-product-itens {
    padding: 8px 16px 0;
    max-width: 100%;
  }
  .new-product-itens-lines > .element-add-edit,
  .new-product-itens-lines > .element-option-select,
  .new-product-itens-lines > .textarea-row {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .space-first,
  .space-second,
  .space-third {
    margin-left: 0;
  }
  .top-space {
    margin-top: 0;
  }
}
@media only screen and (max-width: 480px) {
  .title {
    margin-left: 10px;
    font-size: 14pt;
    line-height: 22px;
  }
  .button-position {
    margin-left: 0;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    gap: 6px;
    padding: 14px 12px 10px;
  }
  .btn-return,
  .btn-save {
    width: 100px;
    height: 38px;
    font-size: 12pt;
    margin: 0;
  }
  .top-space {
    margin-top: 0;
  }
}
.element-add-edit-label,
.element-add-edit-filter {
  font-size: 1.0625rem;
  line-height: 1.35;
  font-weight: 500;
}
.char-counter {
  font-size: 0.875rem;
  line-height: 1.35;
}
::ng-deep .container .p-inputtext,
::ng-deep .container .p-dropdown-label,
::ng-deep .container .p-dropdown-item {
  font-size: 1rem;
  line-height: 1.4;
}
::ng-deep .container .p-message .p-message-text {
  font-size: 0.9375rem;
  line-height: 1.4;
}
/*# sourceMappingURL=new-product.component-CD45G6YZ.css.map */
